<template>
  <card>
    <template v-slot>
      <div class="flex item-start">
        <div class="flex-shrink-0 content-center"><v-shield-check-outline></v-shield-check-outline></div>
        <div class="flex-1">
          <div class="text-2xl font-semibold leading-6 flex-1 mx-2">2FA inschakelen</div>
        </div>
      </div>
      <div class="grid my-2">
        <div class="w-1/3">
          <p>2FA succesvol ingeschakeld. Vanaf nu moet een code worden gebruikt.</p>
          <v-input-group-simple-2
            id="authorizationCode"
            v-model:value="authorizationCode"
            maxlength="6"
            placeholder="Uw verificatiecode"
            data-vv-as="Authorizatie code"
            :overwrite-value="authorizationCode"
            :rules="{
              required: false
            }"
            @input="saveInput($event)"
          />
          <small v-if="authenticationNotEnabled && !showResendText" class="text-red-700 block mx-2 my-4">
            De ingevoerde 2FA code is ongeldig
          </small>
          <small v-if="showResendText && !authenticationNotEnabled" class="text-red-700 block mx-2 my-4">
            Er is een nieuwe code verstuurd naar uw email.
          </small>
          <button
            @click.prevent="resendVerificationCode"
            class="flex justify-center py-2 px-2 md:px-4 border border-primary-color shadow-sm text-xs md:text-sm lg:text-sm font-medium text-primary-color bg-white rounded-full hover:bg-primary-default/50 items-center ml-1"
          >
            <span class="text-black underline font-normal">Code opnieuw versturen</span>
          </button>
        </div>
      </div>
      <div class="flex flex-row justify-end gap-4 mt-4">
        <a
          class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
          @click.prevent="closeEditAuthentication()"
        >
          Annuleren
        </a>
        <button
          :disabled="authorizationCode.length <= 5"
          @click.prevent="enable2FA()"
          class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-cta rounded-full text-nowrap"
        >
          Bevestigen
        </button>
      </div>
    </template>
  </card>
</template>

<script>
import { tap } from 'rxjs/operators';
import VShieldCheckOutline from 'icons/ShieldCheckOutline';
import {
  currentUserIdentity$,
  enable2FactorAuthentication,
  twoFactorAuthenticationNotEnabledEvent$,
  twoFactorAuthenticationEnabledEvent$
} from '@/services';
import { ref, onMounted } from 'vue';

export default {
  name: 'PrescriberTwoFactorEnableAuthModal',
  components: { VShieldCheckOutline },
  setup() {
    const currentUserIdentity = ref(null);
    const twoFactorAuthenticationEnabledEvent = ref(null);
    const authorizationCode = ref('');
    const authenticationNotEnabled = ref(false);
    const showResendText = ref(false);

    currentUserIdentity$.subscribe((value) => (currentUserIdentity.value = value));
    twoFactorAuthenticationEnabledEvent$.subscribe((value) => (twoFactorAuthenticationEnabledEvent.value = value));

    twoFactorAuthenticationNotEnabledEvent$.pipe(
      tap((e) => {
        authorizationCode.value = '';
        authenticationNotEnabled.value = true;
        showResendText.value = false;
      })
    );

    const saveInput = (event) => {
      authorizationCode.value = event.target.value;
    };

    onMounted(() => enable2FactorAuthentication());

    return {
      currentUserIdentity,
      twoFactorAuthenticationEnabledEvent,
      authorizationCode,
      authenticationNotEnabled,
      showResendText,
      saveInput
    };
  },
  methods: {
    closeEditAuthentication() {
      this.$emit('closeEditAuthentication', false);
    },
    resendVerificationCode() {
      enable2FactorAuthentication();
      this.showResendText = true;
      this.authenticationNotEnabled = false;
    },
    async enable2FA() {
      await enable2FactorAuthentication(this.authorizationCode).then((response) => {
        if (response?.data?.length > 1) {
          this.closeEditAuthentication();
          this.$emit('success');
        } else {
          this.$emit('error');
        }
      });
    }
  }
};
</script>
